import { getStore } from "../store/appStore";
import { AppAction } from "../types";
import { TimerActionKey as ActionKey } from "./ActionKeys";

interface StartTimerAction
  extends AppAction<
    ActionKey.TIMER_START,
    {
      initialEpochTime: number;
    }
  > {} // Start timer at this time in seconds.
interface ResetTimerAction extends AppAction<ActionKey.TIMER_RESET> {}
interface SetSessionTimeoutSecondsAction
  extends AppAction<
    ActionKey.SET_SESSION_TIMEOUT_SECONDS,
    { sessionTimeoutSeconds: number }
  > {}

export type TimerAction =
  | StartTimerAction
  | ResetTimerAction
  | SetSessionTimeoutSecondsAction;

export const startTimer = (initialEpochTime: number): StartTimerAction =>
  getStore().dispatch({
    type: ActionKey.TIMER_START,
    payload: { initialEpochTime },
  });

export const resetTimer = (): ResetTimerAction =>
  getStore().dispatch({
    type: ActionKey.TIMER_RESET,
    payload: {},
  });

export const setSessionTimeoutSeconds = (
  sessionTimeoutSeconds: number
): SetSessionTimeoutSecondsAction =>
  getStore().dispatch({
    type: ActionKey.SET_SESSION_TIMEOUT_SECONDS,
    payload: { sessionTimeoutSeconds },
  });
